import { render, staticRenderFns } from "./wedCalculator.vue?vue&type=template&id=17ccaed4&"
import script from "./wedCalculator.vue?vue&type=script&lang=js&"
export * from "./wedCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports